import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface SubmittedDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function SubmittedDialog({ open, onClose }: SubmittedDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="submitted-dialog-title"
      aria-describedby="submitted-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          overflow: 'visible'
        }
      }}
    >
      <DialogTitle id="submitted-dialog-title" sx={{ fontWeight: 'bold' }}>
        Assessment Submitted
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="submitted-dialog-description"
          sx={{
            color: 'text.secondary',
            fontSize: '0.95rem',
            lineHeight: 1.6,
          }}
        >
         Please go back to this assessment responses tab to view or manage this submission,
         also note that you can only submit once per preview, and if auto marker is enabled for 
         this assessment, the score might take a few minutes to reflect.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#10b981",
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1,
            boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
            '&:hover': {
              backgroundColor: "#059669",
              boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
              transform: 'translateY(-1px)'
            },
            transition: 'all 0.2s ease'
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}